module.exports = __webpack_public_path__ + "static/media/image3.3fbb770a.png";